<template>
  <div class="NOTIFICATION">
    <transition name="fade">
      <div v-if="!notification.read" class="UNREAD-INDICATOR"/>
    </transition>
    <div
        v-if="notification.data.summary"
        class="SUMMARY"
        selenium="notification-summary">
      {{ notification.data.summary }}
    </div>
    <div
        v-if="notification.data.content"
        class="CONTENT p-y-2:t"
        selenium="notification-content">
      {{ notification.data.content }}
    </div>
    <div
        v-if="notification.created_dtm"
        class="HOUR"
        selenium="notification-hour">
      {{ notification.created_dtm | calendarDate }} | {{ notification.created_dtm | timeOfDay }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'notification-item',
  props: {
    notification: {
      type: Object,
      required: true,
      validator (notification) {
        const requiredKeys = ['read', 'data'];
        return requiredKeys.every(key => Object.keys(notification).includes(key));
      },
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools.scss";

  .NOTIFICATION {
    @include padding(2 2 1 2);
    display: grid;
    grid-gap: $unit;
    border-bottom: 1px solid $color-gray30;
    grid-template: 'indicator summary hour' auto
                   '.         content content' auto /
                   $unit      2fr     1fr;

    @include tablet {
      &:hover {
        background-color: $color-gray20;
      }
    }
  }

  .UNREAD-INDICATOR {
    @include square($unit);
    display: grid;
    align-self: center;
    border-radius: $unit;
    background-color: $color-depot;
    grid-area: indicator;
  }

  .SUMMARY {
    @include h6;
    font-weight: bold;
    grid-area: summary;
  }

  .CONTENT {
    grid-area: content;
    color: $color-gray70;
  }

  .HOUR {
    @include text-small;
    text-align: right;
    grid-area: hour;
  }
</style>
